export interface SubMeta {
	label: string;
	badge: string; // daisyUI badge colour class
	blurb: string;
}

// The rules behind each label live in drizzle/0008_wallet_performance.sql (checked in this order).
export const SUB_META: Record<string, SubMeta> = {
	market_maker: {
		label: "Market maker",
		badge: "badge-info",
		blurb: "On the market-maker blocklist. Quotes both sides; held-to-resolution ROI is not what they earn.",
	},
	arb_hedger: {
		label: "Arb / hedger",
		badge: "badge-secondary",
		blurb: "Holds both outcomes of 3+ markets. One leg always loses by design.",
	},
	scalper: {
		label: "Scalper",
		badge: "badge-warning",
		blurb: "Averages 15+ trades per position. Many small fills, short holds.",
	},
	sniper: {
		label: "Sniper",
		badge: "badge-accent",
		blurb: "10+ fills at price ≥ 95¢, buying near-certain outcomes just before resolution.",
	},
	insider_longshot: {
		label: "Insider · longshot",
		badge: "badge-primary",
		blurb: "Large one-sided buys, dollar-weighted entry under 20¢.",
	},
	insider_underdog: {
		label: "Insider · underdog",
		badge: "badge-primary",
		blurb: "Large one-sided buys, entry 20–45¢.",
	},
	insider_contested: {
		label: "Insider · contested",
		badge: "badge-primary",
		blurb: "Large one-sided buys, entry 45–75¢.",
	},
	insider_favorite: {
		label: "Insider · favorite",
		badge: "badge-primary",
		blurb: "Large one-sided buys, entry 75¢ or more.",
	},
};

export const subMeta = (key: string): SubMeta =>
	SUB_META[key] ?? { label: key, badge: "badge-ghost", blurb: "" };
